import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import moment from 'moment';

import { Bills } from 'actions/actionTypes';
import * as actions from 'actions/billing/bills';

import { callBills, callBillsDetail } from 'network/apis/billing/bills';

function* loadShopBillsRequestSaga() {
    try {
        const data = {
            page: 1,
            pageSize: 12,
            startDate: moment().subtract(13, 'months').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        };

        const response = yield call(callBills, data);

        yield put(actions.loadShopBillsRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadShopBillsRequestFailure(error.message));
    }
}

function* loadShopBillsDetailRequestSaga() {
    try {
        const bills = yield select((state) => state.bills);

        const response = yield call(callBillsDetail, bills.id);

        yield put(actions.loadShopBillsDetailRequestSuccess(response.data));
    } catch (error) {
        yield put(actions.loadShopBillsDetailRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([takeLatest(Bills.LOAD_SHOP_BILLS_REQUEST, loadShopBillsRequestSaga), takeLatest(Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST, loadShopBillsDetailRequestSaga)]);
}
